import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! @glint-nocheck: not typesafe yet }}\n<div class=\"content\" data-test-content ...attributes>\n  {{yield}}\n</div>")